import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DOCUMENT, NgStyle} from "@angular/common";
import {InitData} from "./init-data";
import {SafePipe} from "../../common/pipes/safe.pipe";
import {FormService} from "./form.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-m2app-form',
  imports: [
    SafePipe,
    NgStyle
  ],
  templateUrl: './m2app-form.component.html',
  styleUrl: './m2app-form.component.scss'
})
export class M2appFormComponent implements OnInit, OnDestroy{
  iFrameUrl = 'https://m2apps.head.com';
  initData: InitData = {
    changeHash: "/head/de-AT/forms/feedback_dam/",
    module: 'forms',
    init: true,
    instanceId: 'test123',
    data: {
      instanceId: 'test123'
    }
  }
  heightSubscription: Subscription | undefined;
  iframeHeight: number | undefined;
  currentLanguage: string | undefined;
  constructor(@Inject(DOCUMENT) private document: Document,
              private formService: FormService) {
  }
  ngOnInit() {
    // console.log('init m2app form component')
    this.heightSubscription = this.formService.getIframeHeight().subscribe(res => {
      this.iframeHeight = res - 34;
    })
  }
  initIframe() {
    const  window =  this.document.querySelector('iframe')?.contentWindow;
    const lang = localStorage.getItem('userLanguage');
    if (lang) {
      this.currentLanguage = lang.replace(/"/g, "");
      this.initData.changeHash = '/head/' + this.currentLanguage + '/forms/feedback_dam/';
    }
    if (window) {
      window.postMessage(this.initData, this.iFrameUrl)
    }
  }
  ngOnDestroy() {
    if (this.heightSubscription) {
      this.heightSubscription.unsubscribe();
    }
  }

}
